import React from "react";

const StoreCardSkeleton = () => {
  return (
    <div className="w-full overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
      {/* Store Header */}
      <div className="flex items-start justify-between border-b border-gray-100 px-4 py-3">
        <div className="w-full">
          <div className="h-4 w-3/5 animate-pulse rounded bg-gray-200" />
        </div>

        <div className="ml-3 h-5 w-5 animate-pulse rounded bg-gray-200" />
      </div>

      {/* Owner + Address */}
      <div className="space-y-3 px-4 py-3">
        {/* Owner + Phone */}
        <div className="flex items-center justify-between gap-4">
          <div className="flex flex-1 items-center gap-2">
            <div className="h-4 w-4 animate-pulse rounded-full bg-gray-200" />

            <div className="h-3 w-28 animate-pulse rounded bg-gray-200" />
          </div>

          <div className="flex items-center gap-1">
            <div className="h-4 w-4 animate-pulse rounded-full bg-gray-200" />

            <div className="h-3 w-20 animate-pulse rounded bg-gray-200" />
          </div>
        </div>

        {/* Address */}
        <div className="flex items-start gap-2">
          <div className="mt-0.5 h-4 w-4 flex-shrink-0 animate-pulse rounded-full bg-gray-200" />

          <div className="w-full space-y-2">
            <div className="h-3 w-full animate-pulse rounded bg-gray-200" />
            <div className="h-3 w-3/4 animate-pulse rounded bg-gray-200" />
          </div>
        </div>
      </div>

      {/* Products */}
      <div className="border-t border-blue-100 bg-blue-50 px-4 py-3">
        {/* Product title */}
        <div className="mb-3 flex items-center gap-2">
          <div className="h-7 w-7 animate-pulse rounded-md bg-blue-100" />

          <div className="h-3 w-28 animate-pulse rounded bg-blue-100" />
        </div>

        {/* Product tabs */}
        <div className="mb-3 flex gap-2">
          <div className="h-6 w-20 animate-pulse rounded-full bg-white" />
          <div className="h-6 w-16 animate-pulse rounded-full bg-white" />
          <div className="h-6 w-20 animate-pulse rounded-full bg-white" />
        </div>

        {/* Type + Size */}
        <div className="grid grid-cols-2 gap-2">
          <div className="rounded-lg border border-blue-100 bg-white px-3 py-2">
            <div className="h-2 w-10 animate-pulse rounded bg-gray-200" />

            <div className="mt-2 h-3 w-20 animate-pulse rounded bg-gray-200" />
          </div>

          <div className="rounded-lg border border-blue-100 bg-white px-3 py-2">
            <div className="h-2 w-10 animate-pulse rounded bg-gray-200" />

            <div className="mt-2 h-3 w-24 animate-pulse rounded bg-gray-200" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoreCardSkeleton;
